"use client";

import { useLinkStatus } from "next/link";
import { useEffect, useRef } from "react";
import { completeNavigationTransition, confirmLinkNavigation } from "./navigation-transition";

export function NavigationLinkStatus({ href }: { href: string }) {
  const { pending } = useLinkStatus();
  const markerRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    if (!pending) {
      return;
    }

    const transitionId = confirmLinkNavigation(href);
    const tabTrigger = markerRef.current?.closest<HTMLElement>('[role="tab"]');
    return () => {
      if (transitionId !== null) {
        completeNavigationTransition(transitionId);
      }
      tabTrigger?.removeAttribute("data-selection-pending");
    };
  }, [href, pending]);

  return (
    <span
      ref={markerRef}
      aria-hidden="true"
      data-navigation-pending={pending ? "true" : undefined}
      hidden
    />
  );
}
